import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import { formatRoute } from 'react-router-named-routes';
import { useNavigate } from 'react-router-dom';
import AddToPlannerModal from '../meal/add_to_planner_modal';
import RecipesEndUserMealCard from './recipes_end_user_meal_card';
import FullWidthMealCard from '../meal/full_width_meal_card';
import EndUserOrganiseRecipeModal from '../meal/end_user_organise_recipe_modal';
import {
  END_USER_RECIPES_BOARD_ROUTE,
  END_USER_RECIPES_GRC_RECIPE_ROUTE,
} from '../../services/routes';
import { showGlobalSnackbar } from '../../features/global_snackbar/global_snackbar_slice';
import {
  useCreateMealMutation,
  useGetGRCRecipesByIDsQuery,
  useLazyGetFullMealQuery,
  useUpdateDbPlannerWeekOptimisticallyMutation,
  useUpdateMealMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import {
  mealWithScaledIngredientsReplaced,
  newMealFromGrcRecipe,
  newMealWithDefaultFields,
} from '../../services/meals';
import {
  dbWeekStartDatesForDayIndexes,
  plannerWeekWithMealAdded,
} from '../../services/planner';
import { deduplicate } from '../../services/arrays';
import {
  scaleMealIngredientsOperation,
  updateFoodBrainDerivedDataOnMeal,
} from '../../operations/meal_operations';
import { useTracker } from '../../operations/tracking_operations';
import { customerFoodDataIDOfSpace } from '../../services/spaces';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
  useLazyGetOrCreateDbPlannerWeekByStartDateQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { getOrCreatePlannerWeeks } from '../../operations/planner_operations';

const RecipesEndUserGRCRecipeItem = ({
  grcRecipeID,
  favouriteEnabled,
  copyEnabled,
  deleteEnabled,
  isFullWidth,
}) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { data: grcRecipes } = useGetGRCRecipesByIDsQuery([grcRecipeID]);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const [lazyGetMeal] = useLazyGetFullMealQuery();

  const [updateMeal] = useUpdateMealMutation();

  const grcRecipe = (grcRecipes || {})[grcRecipeID];

  const [addToPlannerAnchorEl, setAddToPlannerAnchorEl] = useState(null);

  const [copyToBoardAnchorEl, setCopyToBoardAnchorEl] = useState(null);

  const onClickAddToPlanner = (target) => {
    setAddToPlannerAnchorEl(target);
  };

  const tracker = useTracker();

  const { data: userProfile } = useGetUserProfileQuery();

  // const { data: ownedRecipesBoards } = useGetOwnedRecipesBoardsQuery();

  // const favouritesRecipesBoard = myFavouritesRecipesBoard(ownedRecipesBoards);

  // const favouritesMenu =
  //   myFavouritesRecipesBoardDefaultMenu(ownedRecipesBoards);

  // const { data: favouriteDistilledMeals } = useGetDistilledMealsByParentQuery(
  //   favouritesRecipesBoard?.id,
  //   {
  //     skip: !favouritesRecipesBoard?.id,
  //   },
  // );

  // const mealIDInFavourites =
  //   grcRecipe &&
  //   findSimilarMealIDInMenu(
  //     {
  //       recipes: [grcRecipe.recipe],
  //     },
  //     favouritesMenu,
  //     favouriteDistilledMeals,
  //   );

  // const isFavourite = !!mealIDInFavourites;

  // const [deleteMeal] = useDeleteMealMutation();

  const [createMeal] = useCreateMealMutation();

  const [updateDbPlannerWeek] = useUpdateDbPlannerWeekOptimisticallyMutation();

  // const [updateSmorgBoard] = useUpdateSmorgBoardMutation();

  const customerFoodDataID = customerFoodDataIDOfSpace(
    currentSpaceMembership?.spaceID,
  );

  // const myFavouritesMenuID =
  //   myFavouritesRecipesBoardDefaultMenu(ownedRecipesBoards)?.id;

  // const onClickFavourite = useCallback(() => {
  // dispatch(
  //   grcRecipeImportedIntoRecipesBoardAction(
  //     grcRecipeID,
  //     myFavouritesRecipesBoardID,
  //     myFavouritesMenuID,
  //   ),
  // );
  // dispatch(
  //   showGlobalSnackbar({
  //     notificationText: 'Your meal has been added to your favourites',
  //     linkText: 'View favourites',
  //     linkTarget: formatRoute(END_USER_RECIPES_BOARD_ROUTE, {
  //       recipesBoardId: myFavouritesRecipesBoardID,
  //     }),
  //   }),
  // );
  // }, []);

  // const onClickUnfavourite = useCallback(
  //   () =>
  //     unfavouriteMeal(
  //       mealIDInFavourites,
  //       favouritesRecipesBoard,
  //       favouritesMenu,
  //       deleteMeal,
  //       updateSmorgBoard,
  //       dispatch,
  //     ),
  //   [
  //     deleteMeal,
  //     dispatch,
  //     favouritesMenu,
  //     favouritesRecipesBoard,
  //     mealIDInFavourites,
  //     updateSmorgBoard,
  //   ],
  // );
  const [lazyGetOrCreateDbPlannerWeekByStartDate] =
    useLazyGetOrCreateDbPlannerWeekByStartDateQuery();

  const onCopyToPlanner = useCallback(
    async (plannerViewWeekStartDate, dayIndexes, scaleToServings) => {
      const importedMeal = newMealFromGrcRecipe(grcRecipe);
      let newMeal = importedMeal;
      if (scaleToServings !== undefined) {
        if (
          !importedMeal.recipes[0].servings ||
          importedMeal.recipes[0].servings <= 0
        ) {
          console.log('Will not scale meal with no servings');
        } else {
          const scaleFactor =
            scaleToServings / importedMeal.recipes[0].servings;
          const scaledIngredients = await scaleMealIngredientsOperation(
            newMeal,
            scaleFactor,
            customerFoodDataID,
          );
          newMeal = mealWithScaledIngredientsReplaced(
            importedMeal,
            scaleToServings,
            scaledIngredients,
            scaleFactor,
          );
        }
      }
      const dbWeekRecords = dbWeekStartDatesForDayIndexes(
        plannerViewWeekStartDate,
        dayIndexes,
      );
      const dbWeekStartDates = deduplicate(
        dbWeekRecords.map((dbwr) => dbwr.dbWeekStartDate),
      );
      const plannerWeeks = await getOrCreatePlannerWeeks(
        dbWeekStartDates,
        lazyGetOrCreateDbPlannerWeekByStartDate,
      );
      try {
        const currentHealthProGroup = null;
        const insertedMeals = await Promise.all(
          dbWeekRecords.map(async (dbwr) => {
            const plannerWeek = plannerWeeks[dbwr.dbWeekStartDate];
            const { data: insertedMeal } = await createMeal(
              newMealWithDefaultFields(
                newMeal,
                plannerWeek.id,
                currentSpaceMembership.id,
                currentHealthProGroup,
              ),
            );
            return insertedMeal;
          }),
        );
        dbWeekRecords.forEach((dbwr, i) => {
          plannerWeeks[dbwr.dbWeekStartDate] = plannerWeekWithMealAdded(
            plannerWeeks[dbwr.dbWeekStartDate],
            insertedMeals[i],
            dbwr.dayIndex,
          );
        });
        tracker(userProfile, ['Add to planner'], ['numMealsPlanned']);
        await Promise.all(
          insertedMeals.map(async (insertedMeal) =>
            updateFoodBrainDerivedDataOnMeal(
              insertedMeal,
              customerFoodDataID,
              updateMeal,
            ),
          ),
        );
      } finally {
        await Promise.all(
          dbWeekStartDates.map((dbWeekStartDate) =>
            updateDbPlannerWeek(plannerWeeks[dbWeekStartDate]),
          ),
        );
      }
    },
    [
      createMeal,
      currentSpaceMembership.id,
      customerFoodDataID,
      grcRecipe,
      lazyGetOrCreateDbPlannerWeekByStartDate,
      tracker,
      updateDbPlannerWeek,
      updateMeal,
      userProfile,
    ],
  );

  const onClick = useCallback(() => {
    navigate(
      formatRoute(END_USER_RECIPES_GRC_RECIPE_ROUTE, {
        grcRecipeId: grcRecipeID,
      }),
    );
  }, [grcRecipeID, navigate]);

  const calories =
    grcRecipe?.derivedNutrition?.totalNutritionPerServing?.calories;

  // const servings = grcRecipe?.servings;

  const onClickCopyToRecipesBoard = useCallback((target) => {
    setCopyToBoardAnchorEl(target);
  }, []);

  const onCopyToRecipesBoard = useCallback(
    (/* toRecipesBoardId, toMenuId */) => {
      // dispatch(
      //   grcRecipeImportedIntoRecipesBoardAction(
      //     grcRecipeID,
      //     toRecipesBoardId,
      //     toMenuId,
      //   ),
      // );
    },
    [],
  );

  if (!grcRecipe) {
    return null;
  }

  return (
    <>
      {isFullWidth ? (
        <FullWidthMealCard
          mealID={grcRecipeID}
          parentID={null}
          title={grcRecipe.recipe.title}
          imageUrl={grcRecipe.recipe.imageUrl}
          mealTypes={grcRecipe.recipe.mealTypes}
          calories={calories}
          onClick={onClick}
          addToPlannerEnabled
          copyEnabled={copyEnabled}
          favouriteEnabled={false}
          onClickCopyToPlanner={onClickAddToPlanner}
          onClickCopyToRecipesBoard={onClickCopyToRecipesBoard}
        />
      ) : (
        <RecipesEndUserMealCard
          mealID={grcRecipeID}
          parentID={null}
          title={grcRecipe.recipe.title}
          imageUrl={grcRecipe.recipe.imageUrl}
          favouriteEnabled={false}
          deleteEnabled={deleteEnabled}
          onClick={onClick}
          onAddToPlanner={onClickAddToPlanner}
        />
      )}
      {addToPlannerAnchorEl && (
        <AddToPlannerModal
          anchorEl={addToPlannerAnchorEl}
          copyToPlannerEnabled
          editServingsEnabled
          titleText="Schedule"
          onCopyToPlanner={(
            plannerViewWeekStartDate,
            dayIndexes,
            scaleToServings,
          ) => {
            onCopyToPlanner(
              plannerViewWeekStartDate,
              dayIndexes,
              scaleToServings,
            );
            setAddToPlannerAnchorEl(null);
            dispatch(
              showGlobalSnackbar({
                notificationText: 'The meal has been copied to your planner',
                linkText: 'View planner',
                linkTarget: `/planner/${plannerViewWeekStartDate}`,
              }),
            );
          }}
          onDismiss={() => setAddToPlannerAnchorEl(null)}
        />
      )}
      {copyToBoardAnchorEl && (
        <EndUserOrganiseRecipeModal
          recipesBoardId={null}
          menuSelectionEnabled
          anchorEl={copyToBoardAnchorEl}
          onCopy={(toRecipesBoardId, toMenuId) => {
            onCopyToRecipesBoard(toRecipesBoardId, toMenuId);
            setCopyToBoardAnchorEl(null);
            dispatch(
              showGlobalSnackbar({
                notificationText: 'Your meal has been copied to your board',
                linkText: 'View board',
                linkTarget: formatRoute(END_USER_RECIPES_BOARD_ROUTE, {
                  recipesBoardId: toRecipesBoardId,
                }),
              }),
            );
          }}
          onDismiss={() => setCopyToBoardAnchorEl(null)}
          boardTitle="collection"
        />
      )}
    </>
  );
};

RecipesEndUserGRCRecipeItem.propTypes = {
  grcRecipeID: PropTypes.string.isRequired,
  favouriteEnabled: PropTypes.bool.isRequired,
  copyEnabled: PropTypes.bool,
  deleteEnabled: PropTypes.bool.isRequired,
  isFullWidth: PropTypes.bool,
};

RecipesEndUserGRCRecipeItem.defaultProps = {
  copyEnabled: false,
  isFullWidth: false,
};

export default RecipesEndUserGRCRecipeItem;
